import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Modal component for navigation warnings during evaluation completion
 */
const NavigationWarningModal = ({
  show,
  onHide,
  onSaveAndLeave,
  onLeaveWithoutSaving,
  isTimed,
  timeLeft,
  saveButtonLabel = "Save & Leave",
  message = "You have unsaved changes in your evaluation. Navigating away will lose all progress.",
  showSaveButton = true
}) => {
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton className="border-bottom-0 px-4">
        <div className="d-flex flex-column align-items-start justify-content-start w-100">
        <Modal.Title>
          <i className="bi bi-exclamation-triangle-fill text-warning me-2"></i>
          Unsaved Changes

        </Modal.Title>
        <div className="text-hl-warning"></div>
        </div>
      </Modal.Header>
      <Modal.Body className="px-4">
        <p className="mb-3">
          {message}
        </p>
        {isTimed && timeLeft > 0 && (
          <div className="alert alert-info">
            <i className="bi bi-clock me-2"></i>
            <strong>Time remaining:</strong> {formatTime(timeLeft)}
            <br />
            <small>Your timer will be saved if you choose to save and leave.</small>
          </div>
        )}
        <p className="mb-0">
          What would you like to do?
        </p>
      </Modal.Body>
      <Modal.Footer className="px-4 border-top-0">
        <Button variant="secondary" size="sm" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="outline-danger" size="sm" onClick={onLeaveWithoutSaving}>
          Leave Without Saving
        </Button>
        {showSaveButton && (
          <Button variant="primary" size="sm" onClick={onSaveAndLeave}>
            <i className="bi bi-save me-2"></i>
            {saveButtonLabel}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default NavigationWarningModal;
